import React from 'react';
import { Heading, Text, Stack } from '@chakra-ui/react';

interface SectionTitleProps {
  title: string;
  subTitle?: string;
  link?: React.ReactNode;
  noPadding?: boolean;
}

const SectionTitle = ({
  title,
  subTitle,
  link,
  noPadding = false,
}: SectionTitleProps) => (
  <Stack mb={['10', '20']}>
    <Heading
      width="100%"
      textAlign="center"
      fontWeight={800}
      fontSize={['3xl', '3xl', '4xl', '4xl']}
      mb={subTitle ? `${2}` : `${0}`}
      px={noPadding ? undefined : ['5', '16', '32']}
    >
      {title}
    </Heading>
    <Text
      width="100%"
      textAlign="center"
      fontSize="lg"
      mt={subTitle ? `${2}` : `${0}`}
      px={noPadding ? undefined : ['5', '16', '32']}
    >
      {subTitle}
      {link}
    </Text>
  </Stack>
);

SectionTitle.defaultProps = {
  noPadding: false,
  subTitle: null,
  link: null,
};

export default SectionTitle;
